import httpClient from '@/utils/httpClient';
import type { Router } from 'vue-router';

export const fetchData = async <T>(url: string, routerObj: Router): Promise<T | null> => {
  const response = await httpClient.get<T>(url).catch(() => null);
  if (response === null) {
    await routerObj.replace({ name: 'NotFound' });
    return null;
  }
  return response.data;
};
